import {
  AvailabilitySearchResponse,
  DayOfWeek,
} from "../domain_objects/AvailabilitySearchResponse";

export const widgetConfiguratorAvailabilitySearchResponses: AvailabilitySearchResponse[] =
  [
    {
      MicrositeName: "BossaNova",
      TimeSlots: [
        {
          TimeSlot: "2024-06-03T14:15:00",
          IsLeaveTimeRequired: false,
          LeaveTime: "15:15:00",
          ServiceId: 24,
          HasStandardAvailability: true,
          AvailablePromotions: [
            {
              Id: 8,
              FeeAmount: 10,
              LeaveTime: "15:15:00",
              BasePrice: 0,
            },
            {
              Id: 6,
              FeeAmount: 0,
              LeaveTime: "15:15:00",
              BasePrice: 0,
            },
            {
              Id: 7,
              FeeAmount: 0,
              LeaveTime: "15:15:00",
              BasePrice: 0,
            },
          ],
          StandardAvailabilityFeeAmount: 0,
        },
        {
          TimeSlot: "2024-06-03T14:30:00",
          IsLeaveTimeRequired: false,
          LeaveTime: "15:30:00",
          ServiceId: 24,
          HasStandardAvailability: true,
          AvailablePromotions: [
            {
              Id: 8,
              FeeAmount: 10,
              LeaveTime: "15:30:00",
              BasePrice: 0,
            },
            {
              Id: 6,
              FeeAmount: 0,
              LeaveTime: "15:30:00",
              BasePrice: 0,
            },
            {
              Id: 7,
              FeeAmount: 0,
              LeaveTime: "15:30:00",
              BasePrice: 0,
            },
          ],
          StandardAvailabilityFeeAmount: 0,
        },
        {
          TimeSlot: "2024-06-03T14:45:00",
          IsLeaveTimeRequired: false,
          LeaveTime: "15:45:00",
          ServiceId: 24,
          HasStandardAvailability: true,
          AvailablePromotions: [
            {
              Id: 8,
              FeeAmount: 10,
              LeaveTime: "15:45:00",
              BasePrice: 0,
            },
            {
              Id: 6,
              FeeAmount: 0,
              LeaveTime: "15:45:00",
              BasePrice: 0,
            },
            {
              Id: 7,
              FeeAmount: 0,
              LeaveTime: "15:45:00",
              BasePrice: 0,
            },
          ],
          StandardAvailabilityFeeAmount: 0,
        },
        {
          TimeSlot: "2024-06-03T15:00:00",
          IsLeaveTimeRequired: false,
          LeaveTime: "16:00:00",
          ServiceId: 24,
          HasStandardAvailability: true,
          AvailablePromotions: [
            {
              Id: 8,
              FeeAmount: 10,
              LeaveTime: "16:00:00",
              BasePrice: 0,
            },
            {
              Id: 6,
              FeeAmount: 0,
              LeaveTime: "16:00:00",
              BasePrice: 0,
            },
            {
              Id: 7,
              FeeAmount: 0,
              LeaveTime: "16:00:00",
              BasePrice: 0,
            },
          ],
          StandardAvailabilityFeeAmount: 0,
        },
        {
          TimeSlot: "2024-06-03T17:00:00",
          IsLeaveTimeRequired: false,
          LeaveTime: "18:00:00",
          ServiceId: 25,
          HasStandardAvailability: true,
          AvailablePromotions: [
            {
              Id: 8,
              FeeAmount: 10,
              LeaveTime: "18:00:00",
              BasePrice: 0,
            },
            {
              Id: 6,
              FeeAmount: 0,
              LeaveTime: "18:00:00",
              BasePrice: 0,
            },
            {
              Id: 7,
              FeeAmount: 0,
              LeaveTime: "18:00:00",
              BasePrice: 0,
            },
          ],
          StandardAvailabilityFeeAmount: 0,
        },
        {
          TimeSlot: "2024-06-03T17:15:00",
          IsLeaveTimeRequired: false,
          LeaveTime: "18:15:00",
          ServiceId: 25,
          HasStandardAvailability: true,
          AvailablePromotions: [
            {
              Id: 8,
              FeeAmount: 10,
              LeaveTime: "18:15:00",
              BasePrice: 0,
            },
            {
              Id: 6,
              FeeAmount: 0,
              LeaveTime: "18:15:00",
              BasePrice: 0,
            },
            {
              Id: 7,
              FeeAmount: 0,
              LeaveTime: "18:15:00",
              BasePrice: 0,
            },
          ],
          StandardAvailabilityFeeAmount: 0,
        },
        {
          TimeSlot: "2024-06-03T17:30:00",
          IsLeaveTimeRequired: false,
          LeaveTime: "18:30:00",
          ServiceId: 25,
          HasStandardAvailability: true,
          AvailablePromotions: [
            {
              Id: 8,
              FeeAmount: 10,
              LeaveTime: "18:30:00",
              BasePrice: 0,
            },
            {
              Id: 6,
              FeeAmount: 0,
              LeaveTime: "18:30:00",
              BasePrice: 0,
            },
            {
              Id: 7,
              FeeAmount: 0,
              LeaveTime: "18:30:00",
              BasePrice: 0,
            },
          ],
          StandardAvailabilityFeeAmount: 0,
        },
        {
          TimeSlot: "2024-06-03T17:45:00",
          IsLeaveTimeRequired: false,
          LeaveTime: "18:45:00",
          ServiceId: 25,
          HasStandardAvailability: true,
          AvailablePromotions: [
            {
              Id: 8,
              FeeAmount: 10,
              LeaveTime: "18:45:00",
              BasePrice: 0,
            },
            {
              Id: 6,
              FeeAmount: 0,
              LeaveTime: "18:45:00",
              BasePrice: 0,
            },
            {
              Id: 7,
              FeeAmount: 0,
              LeaveTime: "18:45:00",
              BasePrice: 0,
            },
          ],
          StandardAvailabilityFeeAmount: 0,
        },
        {
          TimeSlot: "2024-06-03T18:00:00",
          IsLeaveTimeRequired: false,
          LeaveTime: "19:00:00",
          ServiceId: 25,
          HasStandardAvailability: true,
          AvailablePromotions: [
            {
              Id: 8,
              FeeAmount: 10,
              LeaveTime: "19:00:00",
              BasePrice: 0,
            },
            {
              Id: 6,
              FeeAmount: 0,
              LeaveTime: "19:00:00",
              BasePrice: 0,
            },
            {
              Id: 7,
              FeeAmount: 0,
              LeaveTime: "19:00:00",
              BasePrice: 0,
            },
          ],
          StandardAvailabilityFeeAmount: 0,
        },
        {
          TimeSlot: "2024-06-03T18:15:00",
          IsLeaveTimeRequired: false,
          LeaveTime: "19:15:00",
          ServiceId: 25,
          HasStandardAvailability: true,
          AvailablePromotions: [
            {
              Id: 8,
              FeeAmount: 10,
              LeaveTime: "19:15:00",
              BasePrice: 0,
            },
            {
              Id: 6,
              FeeAmount: 0,
              LeaveTime: "19:15:00",
              BasePrice: 0,
            },
            {
              Id: 7,
              FeeAmount: 0,
              LeaveTime: "19:15:00",
              BasePrice: 0,
            },
          ],
          StandardAvailabilityFeeAmount: 0,
        },
        {
          TimeSlot: "2024-06-03T18:30:00",
          IsLeaveTimeRequired: false,
          LeaveTime: "19:30:00",
          ServiceId: 25,
          HasStandardAvailability: true,
          AvailablePromotions: [
            {
              Id: 8,
              FeeAmount: 10,
              LeaveTime: "19:30:00",
              BasePrice: 0,
            },
            {
              Id: 6,
              FeeAmount: 0,
              LeaveTime: "19:30:00",
              BasePrice: 0,
            },
            {
              Id: 7,
              FeeAmount: 0,
              LeaveTime: "19:30:00",
              BasePrice: 0,
            },
          ],
          StandardAvailabilityFeeAmount: 0,
        },
      ],
      Promotions: [
        {
          Id: 8,
          Name: "Sprint Bloom",
          Description: "Should require payment of £10",
          MayRequireCreditCard: false,
          ValidityPeriods: [
            {
              StartDate: "2024-05-01T00:00:00",
              EndDate: "2024-11-30T00:00:00",
              StartTime: "00:00:00",
              EndTime: "23:59:59",
              Frequency: [
                DayOfWeek.Sunday,
                DayOfWeek.Monday,
                DayOfWeek.Tuesday,
                DayOfWeek.Wednesday,
                DayOfWeek.Thursday,
                DayOfWeek.Friday,
                DayOfWeek.Saturday,
              ],
              IsAlwaysApply: true,
              DayVariables: [],
            },
          ],
          FullPrice: 0,
          MenuVersionId: null,
          MenuName: null,
          MenuUrl: null,
          TakeawayType: 0,
        },
        {
          Id: 6,
          Name: "Summer Fiesta",
          Description: "No payment",
          MayRequireCreditCard: false,
          ValidityPeriods: [
            {
              StartDate: "2024-04-01T00:00:00",
              EndDate: "2024-08-31T00:00:00",
              StartTime: "00:00:00",
              EndTime: "23:59:59",
              Frequency: [
                DayOfWeek.Sunday,
                DayOfWeek.Monday,
                DayOfWeek.Tuesday,
                DayOfWeek.Wednesday,
                DayOfWeek.Thursday,
                DayOfWeek.Friday,
                DayOfWeek.Saturday,
              ],
              IsAlwaysApply: true,
              DayVariables: [],
            },
          ],
          FullPrice: 0,
          MenuVersionId: null,
          MenuName: null,
          MenuUrl: null,
          TakeawayType: 0,
        },
        {
          Id: 7,
          Name: "Winter Wonder",
          Description: "Should require credit card",
          MayRequireCreditCard: true,
          ValidityPeriods: [
            {
              StartDate: "2024-05-01T00:00:00",
              EndDate: "2024-12-31T00:00:00",
              StartTime: "00:00:00",
              EndTime: "23:59:59",
              Frequency: [
                DayOfWeek.Sunday,
                DayOfWeek.Monday,
                DayOfWeek.Tuesday,
                DayOfWeek.Wednesday,
                DayOfWeek.Thursday,
                DayOfWeek.Friday,
                DayOfWeek.Saturday,
              ],
              IsAlwaysApply: true,
              DayVariables: [],
            },
          ],
          FullPrice: 0,
          MenuVersionId: null,
          MenuName: null,
          MenuUrl: null,
          TakeawayType: 0,
        },
      ],
      StandardAvailabilityMayRequireCreditCard: false,
    } as AvailabilitySearchResponse,
    {
      MicrositeName: "BossaNovaNoAvailability",
      TimeSlots: [],
      Promotions: [],
      StandardAvailabilityMayRequireCreditCard: false,
    } as AvailabilitySearchResponse,
  ];
